import {Modal as BootstrapModal, ModalBody, ModalHeader} from 'reactstrap'
import {withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'

import Modal from '../../../../shared/components//Modals/Modal.jsx'

class ConfirmModal extends Modal {
  static propTypes = {
    confirmAction: PropTypes.func,
    onCancel: PropTypes.func,
    body: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    header: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    center: PropTypes.bool,
    confirmText: PropTypes.string,
    cancelClose: PropTypes.func,
  }
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }
  cancel = () => {
    if(this.props.onCancel){
      this.props.onCancel()
    }
    this.props.closeModal()
  }

  confirm = () => {
    this.props.confirmAction()
    this.props.closeModal()
  }

  render() {
    const modalProps = {}
    const {isOpen, body, center, header, confirmText, cancelText} = this.props

    if (!this.state.loading) {
      modalProps.toggle = this.close
    }

    return (
      <BootstrapModal toggle={this.cancel} isOpen={isOpen}>
        <ModalHeader toggle={this.cancel}>{header}</ModalHeader>
        <ModalBody className={center ? "text-center" : ""}>
          <div dangerouslySetInnerHTML={{__html: body}} />
          <div className="d-flex justify-content-around mt-5">
            <button onClick={this.cancel} type="button" className="btn btn-outline-secondary">{cancelText ? cancelText : 'Non'}</button>
            <button onClick={this.confirm} type="button" className="btn btn-secondary">{confirmText ? confirmText : 'Oui'}</button>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}

export default withRouter(ConfirmModal)
